import { render, staticRenderFns } from "./AboutCover.vue?vue&type=template&id=35330ef8&scoped=true&"
import script from "./AboutCover.vue?vue&type=script&lang=js&"
export * from "./AboutCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35330ef8",
  null
  
)

export default component.exports